/* @flow */

import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class ExportAssetDataForm extends React.Component<*> {
  @observable reason: string = 'Other';

  @observable reasonText: string = '';

  render(): React.Node {
    const { currentAccountDetails, actionDrawerStore, t }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className="action-drawer-content">
          <div className="export-asset-data-details">
            <div>{currentAccountDetails.name}</div>
            <div>{currentAccountDetails.number}</div>
          </div>
        </div>
        <h5>{t('general:messages.click_to_download_csv')}</h5>
        <div className="action-drawer-actions">
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.exportAssetData(currentAccountDetails.id)}
          >
            {t('general:actions.download')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
